import React from 'react';
import { injectIntl } from 'react-intl';

import LucideIcon from 'src/componentes/lucide-icon';
import canvasContext from 'src/utils/canvas-context';
import { isNullOrWhiteSpace } from 'src/utils/string';

import { debug } from './index';
class MultilineText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      causaFundamental: props.ehCausaFundamental,
    };
  }

  static measure(props) {
    canvasContext.font = `${props.fontSize}px ${props.fontFamily}`;
    let text = props.text || '';
    let forcedLines = text.split('\n');
    let l = 0;
    let width = 0;
    let lines = [];
    for (let i = 0; i < forcedLines.length; i++) {
      let words = forcedLines[i].split(' ');
      let line = '';
      for (let n = 0; n < words.length; n++) {
        let word = words[n];
        let testLine = line + word + ' ';
        let testLineMetrics = canvasContext.measureText(testLine);
        if (testLineMetrics.width > props.width && n > 0) {
          width = Math.max(width, canvasContext.measureText(line).width);
          lines.push(line);
          l++;
          line = word + ' ';
        } else {
          line = testLine;
        }
      }
      if (line) {
        width = Math.max(width, canvasContext.measureText(line).width);
        lines.push(line);
      }
      l++;
    }
    return {
      width: width,
      height: Math.ceil(l * props.fontSize),
      lines: lines,
    };
  }

  async handleCausaFundamentalClick(text, guid, widgetId) {
    await this.setState({
      causaFundamental: this.state.causaFundamental ? false : true,
    });

    const widget = {
      item: {
        componente: {
          dadosIshikawa: {
            descricao: text,
          },
        },
        id: widgetId,
        causaIshikawaId: guid,
      },
    };

    this.props.handleSaveCausaFundamental(widget, this.state.causaFundamental);
  }

  render() {
    let {
      intl,
      x,
      y,
      width,
      height,
      fontSize,
      fontFamily,
      verticalAlign,
      horizontalAlign,
      text,
      isIshikawaHead,
      ehCausaFundamental,
      destacarCausaRaiz,
      guid,
      widgetId,
      handleSaveCausaFundamental,
    } = this.props;

    let metrics = MultilineText.measure(this.props);

    let startX = 0;
    let startY = 0;

    if (verticalAlign == 'middle') {
      startY -= metrics.height / 2;
    }
    if (verticalAlign == 'bottom') {
      startY -= metrics.height;
    }

    if (horizontalAlign == 'center') {
      startX -= metrics.width / 2;
    } else if (horizontalAlign == 'right') {
      startX -= metrics.width;
    }

    return (
      <g transform={`translate(${x}, ${y})`}>
        {debug && (
          <rect
            x={startX}
            y={startY}
            width={width}
            height={height}
            fill="none"
            stroke="black"
          />
        )}
        {!isIshikawaHead &&
          !isNullOrWhiteSpace(text) &&
          handleSaveCausaFundamental && (
            <foreignObject
              x={startX - 14}
              y={startY - 8}
              width="20"
              height="20"
              style={{ overflow: 'visible' }}
            >
              <div
                xmlns="http://www.w3.org/1999/xhtml"
                onClick={this.handleCausaFundamentalClick.bind(
                  this,
                  text,
                  guid,
                  widgetId
                )}
                style={{ cursor: 'pointer', lineHeight: 0 }}
                title={intl.formatMessage({ id: 'causaFundamental' })}
              >
                <LucideIcon
                  icon={this.state.causaFundamental ? 'StarFilled' : 'Star'}
                  size={16}
                />
              </div>
            </foreignObject>
          )}
        {metrics.lines.map((t, i) => (
          <text
            key={i}
            x={startX}
            y={startY + i * fontSize + fontSize * 0.8}
            fontFamily={fontFamily}
            fontSize={fontSize}
            className={
              destacarCausaRaiz && ehCausaFundamental
                ? 'tw:fill-primary tw:font-bold'
                : undefined
            }
            alignmentBaseline="baseline"
          >
            {t}
          </text>
        ))}
      </g>
    );
  }
}

export default injectIntl(MultilineText);
